import { SelfCheckIn } from '@/api/interface/self-check-in'
import Colors from '@/styles/Colors.module.scss'
import { EventHandler } from 'react'

interface Props {
  settings: SelfCheckIn['settings']
  handleCloseDialog: EventHandler<any>
  sciableName: string
}

export default function LocationRequestContent({
  settings,
  handleCloseDialog,
  sciableName,
}: Props) {
  return (
    <>
      <img src="/img/browser-location-access.png" height="120" width="240" />
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>
        Please allow browser location access.
      </h2>
      <p style={{ margin: '20px 0' }}>
        This waitlist requires you to be nearby the business to join. To check
        this, we need you to allow location access for your browser. If you're
        having trouble, please refer to this{' '}
        <a
          style={{ fontWeight: 'bold' }}
          href="https://www.lifewire.com/turn-on-mobile-location-services-4156232"
          target="_blank"
        >
          Helpful Guide.
        </a>
      </p>
      <button
        className="btn"
        style={{
          width: '100%',
          height: 60,
          fontSize: '1.25rem',
          fontWeight: 'bold',
          marginTop: '0.875rem',
          marginBottom: '1rem',
          borderRadius: '99px',
          backgroundColor:
            settings?.btnBackgroundColor || Colors['theme-green'],
          color: settings?.btnTextColor || Colors['theme-white'],
        }}
        onClick={(e) => {
          handleCloseDialog('closeButton')
        }}
      >
        Done
      </button>
    </>
  )
}
